import { call, put, takeLatest, select } from 'redux-saga/effects'
import carePlan from '../../api/carePlan'
import * as actions from '../slices'
import constants from '../../constants'

// Helper to check if current program is Diasens
const getActiveSupportProgramType = (state) =>
  state.cgm.activeSupportProgramType

// Returns payload with source added for Diasens (used by other APIs)
function* getPayloadWithSource(payload) {
  const activeSupportProgramType = yield select(getActiveSupportProgramType)
  const isDiasens =
    activeSupportProgramType === constants.CARE_PROGRAM_TYPE.DIASENS
  if (isDiasens) {
    return { ...payload, source: 'diasens' }
  }
  return payload
}

export function* verifyMedicationCode(action) {
  try {
    const response = yield call(carePlan.verifyMedicationCode, action.payload)
    if (response.code == 1) {
      yield put(actions.verifyMedicationCodeSuccess(response.data))
    } else {
      yield put(actions.verifyMedicationCodeFailure(response))
    }
  } catch (error) {
    yield put(actions.verifyMedicationCodeFailure(error.message))
  }
}

export function* handleGetStateList(action) {
  try {
    const response = yield call(carePlan.getStateList, action.payload)
    if (Number(response?.code) == 1) {
      yield put(actions.getStateListSuccess(response?.data))
    } else {
      yield put(
        actions.getStateListError(response?.message || constants.ERROR_MSG),
      )
    }
  } catch (error) {
    yield put(actions.getStateListError(error?.message || constants.ERROR_MSG))
    // reject(error)
  }
}

export function* handleGetCityListByState(action) {
  try {
    const response = yield call(carePlan.getCityListByStateId, action.payload)
    if (Number(response?.code) == 1) {
      yield put(actions.getCityListByStateSuccess(response))
    } else {
      yield put(
        actions.getCityListByStateError(
          response?.message || constants.ERROR_MSG,
        ),
      )
    }
  } catch (error) {
    yield put(
      actions.getCityListByStateError(error?.message || constants.ERROR_MSG),
    )
    // reject(error)
  }
}

export function* handleGetDoctorCityList(action) {
  try {
    const payload = yield* getPayloadWithSource(action.payload)
    const response = yield call(carePlan.getDoctorCityList, payload)
    if (Number(response?.code) == 1) {
      yield put(
        actions.getDoctorCityListSuccess({
          data: response?.data,
          pagination: response?.pagination,
          isLoadMore: action.payload?.isLoadMore,
        }),
      )
    } else {
      yield put(
        actions.getDoctorCityListError(
          response?.message || constants.ERROR_MSG,
        ),
      )
    }
  } catch (error) {
    yield put(actions.getDoctorCityListError(constants.ERROR_MSG))
  }
}

export function* handleGetHospitalsInCityList(action) {
  try {
    const payload = yield* getPayloadWithSource(action.payload)
    const response = yield call(carePlan.getHospitalsInCityList, payload)
    if (Number(response?.code) == 1) {
      yield put(
        actions.getHospitalsInCityListSuccess({
          data: response?.data,
          isLoadMore: action.payload?.isLoadMore,
        }),
      )
    } else {
      yield put(
        actions.getHospitalsInCityListError(
          response?.message || constants.ERROR_MSG,
        ),
      )
    }
  } catch (error) {
    yield put(actions.getHospitalsInCityListError(constants.ERROR_MSG))
  }
}

export function* handleGetDoctorsListInHospitalList(action) {
  try {
    const payload = yield* getPayloadWithSource(action.payload)
    const response = yield call(carePlan.getDoctorsListInHospitalList, payload)
    if (Number(response?.code) == 1) {
      yield put(
        actions.getDoctorsListInHospitalListSuccess({
          data: response?.data,
          isLoadMore: action.payload?.isLoadMore,
        }),
      )
    } else {
      yield put(
        actions.getDoctorsListInHospitalListError(
          response?.message || constants.ERROR_MSG,
        ),
      )
    }
  } catch (error) {
    yield put(actions.getDoctorsListInHospitalListError(constants.ERROR_MSG))
  }
}

export function* handleAddDoctor(action) {
  try {
    const response = yield call(carePlan.addDoctor, action.payload)
    if (Number(response?.code) == 1) {
      yield put(actions.addDoctorSuccess(response?.data))
    } else {
      yield put(
        actions.addDoctorError(response?.message || constants.ERROR_MSG),
      )
    }
  } catch (error) {
    yield put(actions.addDoctorError(constants.ERROR_MSG))
  }
}

export function* handleAddHospital(action) {
  try {
    const response = yield call(carePlan.addHospital, action.payload)
    if (Number(response?.code) == 1) {
      yield put(actions.addHospitalSuccess(response?.data))
    } else {
      yield put(
        actions.addHospitalError(response?.message || constants.ERROR_MSG),
      )
    }
  } catch (error) {
    yield put(actions.addHospitalError(constants.ERROR_MSG))
  }
}

export function* carePlanSaga() {
  yield takeLatest(actions.verifyMedicationCodeRequest, verifyMedicationCode)
  yield takeLatest(actions.getStateListRequest, handleGetStateList)
  yield takeLatest(actions.getCityListByStateRequest, handleGetCityListByState)

  // Get Doctor's City List
  yield takeLatest(actions.getDoctorCityListRequest, handleGetDoctorCityList)
  yield takeLatest(
    actions.getHospitalsInCityListRequest,
    handleGetHospitalsInCityList,
  )
  yield takeLatest(
    actions.getDoctorsListInHospitalListRequest,
    handleGetDoctorsListInHospitalList,
  )

  // Add Doctor
  yield takeLatest(actions.addDoctorRequest, handleAddDoctor)
  yield takeLatest(actions.addHospitalRequest, handleAddHospital)
}
